module.exports = __webpack_public_path__ + "media/Momentum_KnokDoorbell_InstallationVideo_Final_Step5-6.5962d4b1.mp4";